import { Component, Input, OnInit } from '@angular/core';
import { ElementType } from 'src/app/_objects/element-type';
import { ReportRectangle } from 'src/app/_objects/report-rectangle';
import { FromToDetail } from 'src/app/_objects/report-template';
import { MousePoint, Notifier, ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';

@Component({
    selector: 'app-report-rectangle-container',
    templateUrl: './report-rectangle.component.html',
    styleUrls: ['./report-rectangle.component.scss'],
    standalone: false
})
export class ReportRectangleComponent implements OnInit {

  @Input() public pageKey: string;
  @Input() public rectangleKey: string;
  @Input() public elementLocation: string;

  public reportRectangle: ReportRectangle;
  private resizeMarkerSize: number;
  private resizing: boolean;
  private notifier: Notifier;
  public isCustomDrawEnable: boolean;

  constructor(
    public designService: ReportTemplateDesignService
  ) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'report-rectangle.component',
      ids: { pageId: this.pageKey, elementId: this.rectangleKey }
    };
    this.isCustomDrawEnable = this.designService.customElementAdd;
    this.reportRectangle = this.designService.getRectangle(this.rectangleKey);
    let elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey == this.pageKey)[0]
    .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
      .elements;

     elementNavigator.filter(x=>x.elementName == ElementType.Rectangle).length > 0
      ? elementNavigator.filter(x=>x.elementName == ElementType.Rectangle)[0].elementData.push({
          id: this.rectangleKey,
          page: this.pageKey,
          name: this.reportRectangle.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.Rectangle,
          isVisible: false,
          elementData: [
            {
              id: this.rectangleKey,
              page: this.pageKey,
              name: this.reportRectangle.getTitle(),
            },
          ],
        });
  }

  public onClick(event: MouseEvent) {
    if (this.reportRectangle.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.rectangleKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  public onDragStart(event: DragEvent) {
    // console.log('ReportRectangle onDragStart');
    event.dataTransfer.setData('text', this.rectangleKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportRectangle.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.Rectangle, fromDetail, dragPoint);
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportRectangle onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportRectangle onDrop');
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportRectangle.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportRectangle.getLeftPx() + event.offsetX,
      onElementY: this.reportRectangle.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportRectangle.getWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportRectangle.getWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch(vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportRectangle.getHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportRectangle.getHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY});
    }
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    this.designService.notifyBeginResize(this.notifier, ElementType.Text, horizontal, vertical, beginPoint);
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
